import axios from "axios";

const URL = {
    base: '/api/cdk/terminal/v1/',
}

const HEADERS = {
    "Content-Type": "application/json"
}

const TerminalService = {
    getTerminals: async () => {

        try {

            const response = await axios.get(`${URL.base}`, {headers: HEADERS});
            const terminals = response.data;

            return terminals;

        } catch (e) {
            console.error('An error has occurred while trying to load the terminals', e);
            return {hasError: true};
        }

    }
}

export default TerminalService;